export const DISMISSED_AT = 'dismissedAt';
export const VIEWED_COUNT = 'viewedCount';